module.exports = __webpack_public_path__ + "media/images/demo/toggle-menu-1d1eeef42ed3beb9963c7ffde6fe4a0f.jpg";